export default __webpack_public_path__ + "static/media/company.3869b04a.png";